<div class="gl-page">

  <div class="gl-page-header">
    <div class="gl-page-subtitle">{{ 'LISTADOS.SUBTITLE' | translate }}</div>
    <button type="button" class="em-btn em-btn--primary" (click)="abrirNuevoListado()">
      <mat-icon>add</mat-icon> {{ 'LISTADOS.NEW' | translate }}
    </button>
  </div>

  <div class="gl-master-detail">

    <!-- ============== PANEL IZQUIERDO ============== -->
    <aside class="gl-master">
      <div class="gl-toolbar">
        <input type="text" class="em-input" [placeholder]="'LISTADOS.SEARCH_PH' | translate"
               [value]="filtroSearchControl" (input)="onSearchChange($any($event.target).value)" />
        <select class="em-select" [ngModel]="filtroEstado" (ngModelChange)="onEstadoChange($event)">
          <option value="todos">{{ 'LISTADOS.ALL' | translate }}</option>
          <option value="activos">{{ 'COMMON.ACTIVE' | translate }}</option>
          <option value="inactivos">{{ 'COMMON.INACTIVE' | translate }}</option>
        </select>
      </div>

      <!-- Form inline nuevo listado -->
      <div *ngIf="showNewListadoForm" class="gl-inline-form">
        <ng-container *ngTemplateOutlet="listadoFormTpl; context: { isNew: true }"></ng-container>
      </div>

      <div class="gl-cards">
        <div *ngFor="let l of listados"
             class="gl-card"
             [class.gl-card--active]="l.id === selectedId"
             (click)="select(l)">
          <div class="gl-card__header">
            <span class="gl-mono">{{ l.codigo }}</span>
            <span class="gl-badge"
                  [class.gl-badge--active]="l.activo"
                  [class.gl-badge--inactive]="!l.activo">
              {{ l.activo ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate) }}
            </span>
          </div>
          <div class="gl-card__name">{{ l.nombre }}</div>
          <div class="gl-card__footer">
            <span>{{ 'LISTADOS.OPTIONS_ACTIVE' | translate:{activas: countActivas(l), total: countTotal(l)} }}</span>
            <span>{{ 'LISTADOS.ORDER' | translate:{orden: l.orden} }}</span>
          </div>
        </div>
        <div *ngIf="!loading && listados.length === 0" class="gl-empty">
          {{ 'LISTADOS.EMPTY' | translate }}
        </div>
      </div>
    </aside>

    <!-- ============== PANEL DERECHO ============== -->
    <section class="gl-detail">
      <ng-container *ngIf="selected; else noSelection">
        <div class="gl-detail__topbar">
          <div>
            <div class="gl-detail__title">{{ selected.nombre }}</div>
            <div class="gl-detail__code">{{ selected.codigo }}</div>
          </div>
          <div class="gl-detail__badges">
            <span class="gl-badge"
                  [class.gl-badge--active]="selected.activo"
                  [class.gl-badge--inactive]="!selected.activo">
              {{ selected.activo ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate) }}
            </span>
            <span class="gl-badge gl-badge--count">{{ 'LISTADOS.N_OPTIONS' | translate:{count: selected.opciones.length} }}</span>
          </div>
          <div class="gl-detail__actions">
            <button type="button" class="gl-btn gl-btn--ghost-sm" (click)="abrirEditarListado()" *ngIf="!editingListado">
              <mat-icon>edit</mat-icon> {{ 'LISTADOS.EDIT_LIST' | translate }}
            </button>
            <button type="button" class="gl-btn gl-btn--danger-sm" (click)="confirmarEliminarListado()" *ngIf="!editingListado">
              <mat-icon>delete</mat-icon> {{ 'COMMON.DELETE' | translate }}
            </button>
          </div>
        </div>

        <!-- Form inline editar listado -->
        <div *ngIf="editingListado" class="gl-inline-form">
          <ng-container *ngTemplateOutlet="listadoFormTpl; context: { isNew: false }"></ng-container>
        </div>

        <div *ngIf="!editingListado && selected.descripcion" class="gl-description">
          {{ selected.descripcion }}
        </div>

        <!-- ============== TABLA DE OPCIONES ============== -->
        <div class="gl-section">
          <div class="gl-section__header">
            <span class="gl-section-label">{{ 'LISTADOS.OPTIONS_TITLE' | translate }}</span>
            <button type="button" class="gl-btn gl-btn--primary-sm"
                    (click)="abrirNuevaOpcion()" *ngIf="!showNewOpcionRow">
              <mat-icon>add</mat-icon> {{ 'LISTADOS.NEW_OPTION' | translate }}
            </button>
          </div>

          <div class="gl-table-wrapper listado listado--cards-accent">
            <table class="gl-table">
              <thead>
                <tr>
                  <th class="gl-col-orden">{{ 'LISTADOS.COL_ORD' | translate }}</th>
                  <th>{{ 'LISTADOS.COL_LABEL' | translate }}</th>
                  <th>{{ 'LISTADOS.COL_VALUE' | translate }}</th>
                  <th class="gl-col-estado">{{ 'COMMON.STATUS' | translate }}</th>
                  <th class="em-th-actions">{{ 'COMMON.ACTIONS' | translate }}</th>
                </tr>
              </thead>
              <tbody>

                <!-- Fila inline de nueva opción -->
                <tr *ngIf="showNewOpcionRow" [formGroup]="opcionForm" class="gl-row-edit">
                  <td [attr.data-label]="'LISTADOS.COL_ORD' | translate"><input type="number" min="1" class="em-input em-input--sm" formControlName="orden" /></td>
                  <td data-role="title" [attr.data-label]="'LISTADOS.COL_LABEL' | translate"><input type="text" class="em-input em-input--sm" formControlName="etiqueta" [placeholder]="'LISTADOS.LABEL_PH' | translate" /></td>
                  <td [attr.data-label]="'LISTADOS.COL_VALUE' | translate"><input type="text" class="em-input em-input--sm gl-mono" formControlName="valor" [placeholder]="'LISTADOS.VALUE_PH' | translate" /></td>
                  <td [attr.data-label]="'COMMON.STATUS' | translate" data-role="status">
                    <label class="fb-toggle fb-toggle--sm">
                      <input type="checkbox" formControlName="activo" />
                      <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
                    </label>
                  </td>
                  <td data-role="actions" class="em-td-actions">
                    <button type="button" class="em-icon-btn" (click)="cancelarNuevaOpcion()" [title]="'COMMON.CLOSE' | translate">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button type="button" class="em-icon-btn em-icon-btn--primary"
                            [disabled]="!opcionForm.valid" (click)="guardarNuevaOpcion()" [title]="'COMMON.SAVE' | translate">
                      <mat-icon>check</mat-icon>
                    </button>
                  </td>
                </tr>

                <ng-container *ngFor="let op of opcionesOrdenadas(selected)">

                  <!-- Fila edición inline -->
                  <tr *ngIf="editingOpcionId === op.id" [formGroup]="opcionForm" class="gl-row-edit">
                    <td [attr.data-label]="'LISTADOS.COL_ORD' | translate"><input type="number" min="1" class="em-input em-input--sm" formControlName="orden" /></td>
                    <td data-role="title" [attr.data-label]="'LISTADOS.COL_LABEL' | translate"><input type="text" class="em-input em-input--sm" formControlName="etiqueta" /></td>
                    <td [attr.data-label]="'LISTADOS.COL_VALUE' | translate"><input type="text" class="em-input em-input--sm gl-mono" formControlName="valor" /></td>
                    <td [attr.data-label]="'COMMON.STATUS' | translate" data-role="status">
                      <label class="fb-toggle fb-toggle--sm">
                        <input type="checkbox" formControlName="activo" />
                        <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
                      </label>
                    </td>
                    <td data-role="actions" class="em-td-actions">
                      <button type="button" class="em-icon-btn" (click)="cancelarEditarOpcion()" [title]="'COMMON.CLOSE' | translate">
                        <mat-icon>close</mat-icon>
                      </button>
                      <button type="button" class="em-icon-btn em-icon-btn--primary"
                              [disabled]="!opcionForm.valid" (click)="guardarEdicionOpcion()" [title]="'COMMON.SAVE' | translate">
                        <mat-icon>check</mat-icon>
                      </button>
                    </td>
                  </tr>

                  <!-- Fila visualización -->
                  <tr *ngIf="editingOpcionId !== op.id" [class.gl-row-inactive]="!op.activo">
                    <td [attr.data-label]="'LISTADOS.COL_ORD' | translate">
                      <span class="gl-orden-badge">{{ op.orden }}</span>
                      <span class="gl-arrows">
                        <button type="button" class="gl-arrow-btn" [disabled]="primeraOpcion(selected, op)"
                                (click)="moverOpcion(op, 'up')" [title]="'COMMON.UP' | translate">
                          <mat-icon>arrow_upward</mat-icon>
                        </button>
                        <button type="button" class="gl-arrow-btn" [disabled]="ultimaOpcion(selected, op)"
                                (click)="moverOpcion(op, 'down')" [title]="'COMMON.DOWN' | translate">
                          <mat-icon>arrow_downward</mat-icon>
                        </button>
                      </span>
                    </td>
                    <td data-role="title" [attr.data-label]="'LISTADOS.COL_LABEL' | translate"><strong>{{ op.etiqueta }}</strong></td>
                    <td [attr.data-label]="'LISTADOS.COL_VALUE' | translate"><span class="gl-mono">{{ op.valor }}</span></td>
                    <td [attr.data-label]="'COMMON.STATUS' | translate" data-role="status">
                      <label class="fb-toggle fb-toggle--sm">
                        <input type="checkbox" [checked]="op.activo" (change)="toggleActivoOpcion(op)" />
                        <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
                      </label>
                    </td>
                    <td data-role="actions" class="em-td-actions">
                      <button type="button" class="em-icon-btn" (click)="abrirEditarOpcion(op)" [title]="'COMMON.EDIT' | translate">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button type="button" class="em-icon-btn em-icon-btn--danger" (click)="confirmarEliminarOpcion(op)" [title]="'COMMON.DELETE' | translate">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>

                <tr *ngIf="!showNewOpcionRow && opcionesOrdenadas(selected).length === 0">
                  <td colspan="5" class="gl-empty-row">
                    {{ 'LISTADOS.EMPTY_OPTIONS' | translate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="gl-summary" *ngIf="selected.opciones.length > 0">
            <span><strong class="gl-text-success">{{ countActivas(selected) }}</strong> {{ 'LISTADOS.SUMMARY_ACTIVE' | translate }}</span>
            <span><strong class="gl-text-muted">{{ selected.opciones.length - countActivas(selected) }}</strong> {{ 'LISTADOS.SUMMARY_INACTIVE' | translate }}</span>
            <span>{{ 'LISTADOS.SUMMARY_TOTAL' | translate }} <strong>{{ selected.opciones.length }}</strong></span>
          </div>
        </div>
      </ng-container>

      <ng-template #noSelection>
        <div class="gl-empty">{{ 'LISTADOS.NO_SELECTION' | translate }}</div>
      </ng-template>
    </section>
  </div>
</div>

<!-- ============== TEMPLATE: form de listado (reutilizado para crear y editar) ============== -->
<ng-template #listadoFormTpl let-isNew="isNew">
  <form [formGroup]="listadoForm" class="gl-form">
    <div class="gl-form__title">{{ isNew ? ('LISTADOS.NEW_TITLE' | translate) : ('LISTADOS.EDIT_TITLE' | translate) }}</div>

    <div class="gl-form-grid">
      <div class="gl-field">
        <label>{{ 'LISTADOS.CODE' | translate }}</label>
        <input type="text" class="em-input gl-mono" formControlName="codigo"
               [placeholder]="'LISTADOS.CODE_PH' | translate"
               (input)="onCodigoChange($any($event.target).value)" />
        <span class="gl-error" *ngIf="listadoForm.get('codigo')?.touched && listadoForm.get('codigo')?.invalid">
          {{ 'LISTADOS.CODE_ERROR' | translate }}
        </span>
      </div>
      <div class="gl-field">
        <label>{{ 'LISTADOS.ORDER_L' | translate }}</label>
        <input type="number" min="1" class="em-input" formControlName="orden" />
      </div>
      <div class="gl-field gl-field--full">
        <label>{{ 'LISTADOS.NAME' | translate }}</label>
        <input type="text" class="em-input" formControlName="nombre" [placeholder]="'LISTADOS.NAME_PH' | translate" />
      </div>
      <div class="gl-field gl-field--full">
        <label>{{ 'LISTADOS.DESC' | translate }}</label>
        <textarea class="em-input gl-textarea" rows="2" formControlName="descripcion"
                  [placeholder]="'LISTADOS.DESC_PH' | translate"></textarea>
      </div>
      <div class="gl-field gl-field--full">
        <label class="fb-toggle">
          <input type="checkbox" formControlName="activo" />
          <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
          <span class="fb-toggle__text">{{ listadoForm.get('activo')?.value ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate) }}</span>
        </label>
      </div>
    </div>

    <div class="gl-form__actions">
      <button type="button" class="gl-btn gl-btn--ghost" (click)="isNew ? cancelarNuevoListado() : cancelarEditarListado()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="gl-btn gl-btn--primary"
              [disabled]="!listadoForm.valid"
              (click)="isNew ? guardarNuevoListado() : guardarEdicionListado()">
        <mat-icon>{{ isNew ? 'add' : 'check' }}</mat-icon>
        {{ isNew ? ('LISTADOS.CREATE' | translate) : ('LISTADOS.SAVE_CHANGES' | translate) }}
      </button>
    </div>
  </form>
</ng-template>
